import React from 'react'

export const FantasticaLogo: React.FC = () => (
  <svg
    id="Camada_1"
    data-name="Camada 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 479.13 246.77"
  >
    <defs>
      <linearGradient
        id="Gradiente_sem_nome"
        x1="-438.86"
        y1="505.34"
        x2="-439.75"
        y2="504.85"
        gradientTransform="matrix(204.48, 0, 0, -102.24, 90150.74, 51823.46)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00ffe5" />
        <stop offset="1" stopColor="#1aaecc" />
      </linearGradient>
      <linearGradient
        id="Gradiente_sem_nome_2"
        x1="-429.96"
        y1="504.81"
        x2="-430.54"
        y2="504.22"
        gradientTransform="matrix(39.93, 0, 0, -83.82, 17437.94, 42466.01)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="Gradiente_sem_nome_3"
        x1="-433.47"
        y1="504.28"
        x2="-433.47"
        y2="503.28"
        gradientTransform="matrix(55.05, 0, 0, -69.87, 24168.29, 35411.37)"
        xlinkHref="#Gradiente_sem_nome_2"
      />
      <linearGradient
        id="Gradiente_sem_nome_4"
        x1="-431.69"
        y1="504.07"
        x2="-431.69"
        y2="503.07"
        gradientTransform="matrix(45.07, 0, 0, -66.17, 19824.65, 33518.05)"
        xlinkHref="#Gradiente_sem_nome_2"
      />
      <linearGradient
        id="Gradiente_sem_nome_5"
        x1="-438.25"
        y1="505.46"
        x2="-438.25"
        y2="504.46"
        gradientTransform="matrix(136.06, 0, 0, -102.24, 59925.57, 51822.96)"
        xlinkHref="#Gradiente_sem_nome_2"
      />
    </defs>
    <g id="logo_v3--dark" data-name="logo v3--dark">
      <g id="cog">
        <path
          id="Subtração_48"
          data-name="Subtração 48"
          d="M326.92,246.77H299.17a5.85,5.85,0,0,1-5.84-5.84l-3.09-19.14a80.78,80.78,0,0,1-15.83-6.41l-15.59,11.26a5.84,5.84,0,0,1-8.26,0L230.94,207a5.84,5.84,0,0,1,0-8.26h0L242,183.42a80.17,80.17,0,0,1-6.77-16.17l-18.59-3a5.86,5.86,0,0,1-5.84-5.85V144.53h54.78a46.74,46.74,0,0,0,93.47,0h56.24V158.4a5.86,5.86,0,0,1-5.85,5.85l-20.12,3.24a80.31,80.31,0,0,1-6.07,14.78l11.9,16.48a5.84,5.84,0,0,1,0,8.26h0l-19.62,19.63a5.84,5.84,0,0,1-8.26,0h0l-16.22-11.72a80.6,80.6,0,0,1-15.13,6.42l-3.16,19.59A5.84,5.84,0,0,1,326.92,246.77Z"
          transform="translate(0 0)"
          fill="url(#Gradiente_sem_nome)"
        />
        <path
          id="Interseção_1"
          data-name="Interseção 1"
          d="M250.56,226.64,230.94,207a5.84,5.84,0,0,1,0-8.26L242,183.42a79.27,79.27,0,0,1-6.77-16.17l-5.49-.89a290.13,290.13,0,0,1,19.94-21.83h15.89a46.64,46.64,0,0,0,3.58,18c-7.87,21.45-4.76,43.06-.84,57.27l-9.5,6.86A5.84,5.84,0,0,1,250.56,226.64Z"
          transform="translate(0 0)"
          style={{ opacity: 0.36000001430511475, isolation: 'isolate' }}
          fill="url(#Gradiente_sem_nome_2)"
        />
        <path
          id="Interseção_2"
          data-name="Interseção 2"
          d="M301.44,246.77c-11.38-27-18.92-54.15-22.81-69.87l.65.66a47.28,47.28,0,0,0,10.78,8.08,109.5,109.5,0,0,0,43.62,49.6l-.92,5.69a5.84,5.84,0,0,1-5.84,5.84Z"
          transform="translate(0 0)"
          style={{ opacity: 0.36000001430511475, isolation: 'isolate' }}
          fill="url(#Gradiente_sem_nome_3)"
        />
        <path
          id="Interseção_3"
          data-name="Interseção 3"
          d="M367.27,226.64l-13.19-9.53a136.48,136.48,0,0,0-7-41.33,46.85,46.85,0,0,0,8.56-13.61c25.65,16.76,34,35.12,36.5,47.89l-16.57,16.58a5.84,5.84,0,0,1-8.26,0Z"
          transform="translate(0 0)"
          style={{ opacity: 0.36000001430511475, isolation: 'isolate' }}
          fill="url(#Gradiente_sem_nome_4)"
        />
        <path
          id="Interseção_4"
          data-name="Interseção 4"
          d="M299.17,246.77a5.84,5.84,0,0,1-5.84-5.84l-3.09-19.14a80.78,80.78,0,0,1-15.83-6.41l-15.59,11.26a5.84,5.84,0,0,1-8.26,0h0L230.94,207A5.87,5.87,0,0,1,229.6,205c51.73,7.21,81.59-3,98.83-16.55a46.79,46.79,0,0,0,30.62-43.87h3.7c6.67,27,.81,53.59-7,73.79l-4.71-3.4a79.55,79.55,0,0,1-15.12,6.41l-3.16,19.6a5.85,5.85,0,0,1-5.84,5.84Z"
          transform="translate(0 0)"
          style={{ opacity: 0.36000001430511475, isolation: 'isolate' }}
          fill="url(#Gradiente_sem_nome_5)"
        />
      </g>
      <g id="fabrica">
        <path
          id="União_27"
          data-name="União 27"
          d="M1,129.18a1,1,0,0,1-1-1v-55s-1.17-12.73,12.39-13.6a1,1,0,0,1,.3,0H69.13a1,1,0,0,1,1,1V71.65a1,1,0,0,1-1,1h-56V88.14H56a1,1,0,0,1,1,1v11.14a1,1,0,0,1-1,1H13.17v26.9a1,1,0,0,1-1,1Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
        <path
          id="União_28"
          data-name="União 28"
          d="M134.2,129H95.72l-.93,0-.94,0H92.13a1,1,0,0,1-.63-.22c-9.34-1.46-10.52-9.18-10.61-12.2,0,0,0-.08,0-.12V100.25a1.35,1.35,0,0,1,0-.28c.26-3.55,2-11.09,12.32-11.77a.85.85,0,0,1,.36-.06h34.51a1,1,0,0,1,1,1v11.14a1,1,0,0,1-1,1H94v14.61h41.83V72.65H93.6a1,1,0,0,1-1-1V60.51a1,1,0,0,1,1-1h43.28a.8.8,0,0,1,.43.1C149.93,60.83,149,72.74,149,73.14v42.27c0,.4.92,12.34-11.74,13.54a1.09,1.09,0,0,1-.39.08h-.81l-.93,0Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
        <path
          id="União_29"
          data-name="União 29"
          d="M215.69,129H165.16a1,1,0,0,1-1-1V116.89a1,1,0,0,1,1-1h52.5V72.65h-52.5a1,1,0,0,1-.85-.49,1,1,0,0,1-.7-1V33.06a1,1,0,0,1,1-1h11.15a1,1,0,0,1,1,1V59.51h41.91a.91.91,0,0,1,.43.1c12.84,1.24,11.7,13.54,11.7,13.54v42.27a10.68,10.68,0,0,1,0,1.6V118a1,1,0,0,1-.15.54c-.58,3.74-2.88,9.67-11.64,10.48a1,1,0,0,1-.34.06h-.49c-.41,0-.83,0-1.25,0S216.08,129.05,215.69,129Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
        <path
          id="União_30"
          data-name="União 30"
          d="M246.41,129.18a1,1,0,0,1-1-1v-55h0S244.19,60,258.48,59.52h31.76a1,1,0,0,1,1,1V71.65a1,1,0,0,1-1,1H258.55v55.53a1,1,0,0,1-1,1Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
        <rect
          id="Retângulo_41"
          data-name="Retângulo 41"
          x="305.29"
          y="59.82"
          width="13.15"
          height="69.36"
          rx="1"
          fill="#ffffff"
        />
        <path
          id="União_31"
          data-name="União 31"
          d="M346.24,129h-.49a1,1,0,0,1-.34-.06c-8.76-.81-11.06-6.74-11.64-10.48a1,1,0,0,1-.15-.54V117a10.68,10.68,0,0,1,0-1.6V73.15s-1.14-12.3,11.7-13.54a.8.8,0,0,1,.43-.1h53.5a1,1,0,0,1,1,1V71.65a1,1,0,0,1-1,1H346.76v43.24h52.49a1,1,0,0,1,1,1V128a1,1,0,0,1-1,1H348.73c-.39,0-.8,0-1.24,0S346.64,129.05,346.24,129Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
        <path
          id="União_32"
          data-name="União 32"
          d="M464.29,129H425.81l-.93,0-.94,0h-1.71a1,1,0,0,1-.63-.22c-9.34-1.46-10.52-9.18-10.61-12.2a.49.49,0,0,1,0-.12V100.25a.9.9,0,0,1,0-.28c.26-3.55,2-11.09,12.32-11.77a.83.83,0,0,1,.35-.06h34.52a1,1,0,0,1,1,1v11.14a1,1,0,0,1-1,1H424.12v14.61H466V72.65H423.69a1,1,0,0,1-1-1V60.51a1,1,0,0,1,1-1H467a.86.86,0,0,1,.44.1c12.83,1.24,11.7,13.54,11.7,13.54v42.26s1.14,12.32-11.75,13.55a1,1,0,0,1-.39.07h-.8c-.31,0-.62,0-.94,0Z"
          transform="translate(0 0)"
          fill="#ffffff"
        />
      </g>
      <path
        id="de_Sites"
        data-name="de Sites"
        d="M24.19,144.28v37.34H20.34v-1.77a15.76,15.76,0,0,1-7.9,2.29,11.5,11.5,0,0,1-3.64-.52,7.48,7.48,0,0,1-2.91-1.87q-2.82-2.81-2.81-10.38T5.6,158.45q2.52-3.34,8.35-3.35a32.06,32.06,0,0,1,6.4.68v-11.5ZM8.9,176.94a4.51,4.51,0,0,0,1.77,1.35,6.88,6.88,0,0,0,2.42.37,13,13,0,0,0,3.33-.5,20.7,20.7,0,0,0,2.88-1l1-.47V159.1a33.83,33.83,0,0,0-6.19-.62q-3.95,0-5.51,2.52t-1.56,7.83Q7.08,174.86,8.9,176.94Zm40.51,1.46,1.51-.16.1,3.07a76.6,76.6,0,0,1-10.14.83q-5.62,0-8-3.25t-2.34-10.11q0-13.68,10.87-13.68,5.25,0,7.85,2.94c1.74,2,2.6,5,2.6,9.23l-.21,3H34.54q0,4.32,1.56,6.4t5.43,2.08C44.11,178.71,46.74,178.6,49.41,178.4ZM48,167.11q0-4.79-1.53-6.76c-1-1.32-2.69-2-5-2a6.36,6.36,0,0,0-5.2,2.08q-1.74,2.07-1.8,6.65ZM80,148.6q-7.8,0-7.8,5.88,0,3.27,1.79,4.5c1.2.81,3.62,1.63,7.28,2.44s6.25,1.87,7.78,3.17S91.38,168,91.38,171q0,11.09-11.5,11.08a64.7,64.7,0,0,1-9.52-.89l-1.87-.26.42-3.32a88.25,88.25,0,0,0,10.77.93q7.69,0,7.7-7.23a4.89,4.89,0,0,0-1.69-4.18c-1.13-.85-3.23-1.57-6.32-2.16-4.06-.87-6.93-2-8.63-3.35s-2.55-3.67-2.56-6.89q0-9.68,11.6-9.68a66,66,0,0,1,9.1.78l1.77.26-.37,3.38A97.31,97.31,0,0,0,80,148.6Zm17.57,33v-26h3.9v26Zm0-31.88v-4.52h3.9v4.52ZM122.47,159H114.2v12.43q0,4.47.65,5.87c.44.94,1.47,1.41,3.1,1.4l4.62-.31.26,3.23a36.24,36.24,0,0,1-5.3.57q-4.05,0-5.62-2t-1.56-7.54V159h-3.69v-3.38h3.69v-8h3.85v8h8.27Zm22.46,19.4,1.51-.16.1,3.07a73.23,73.23,0,0,1-10.14.83q-5.61,0-8-3.25t-2.34-10.11q0-13.68,10.86-13.68c3.51,0,6.12,1,7.86,2.94s2.6,5,2.6,9.23l-.21,3H130.06c0,2.87.52,5,1.56,6.4s2.85,2.08,5.43,2.08,5.21-.12,7.88-.32Zm-1.4-11.28c0-3.19-.51-5.45-1.53-6.76s-2.69-2-5-2a6.39,6.39,0,0,0-5.2,2.08c-1.16,1.39-1.76,3.6-1.8,6.66Zm18.15-8.54q-5.67,0-5.67,4a2.73,2.73,0,0,0,1.3,2.57,22.09,22.09,0,0,0,5.93,1.56c3.08.54,5.27,1.29,6.55,2.26s1.92,2.79,1.92,5.46-.85,4.63-2.57,5.88-4.22,1.87-7.51,1.87a47.25,47.25,0,0,1-7.6-.73l-1.55-.26.21-3.38a66.84,66.84,0,0,0,8.94.89,9,9,0,0,0,4.6-1,3.46,3.46,0,0,0,1.59-3.22,3.3,3.3,0,0,0-1.36-3.07,19.88,19.88,0,0,0-5.92-1.53q-4.57-.74-6.5-2.13t-1.93-5.2a6.32,6.32,0,0,1,2.68-5.62,11.6,11.6,0,0,1,6.68-1.82,54.4,54.4,0,0,1,8,.73l1.45.26-.1,3.33A66.06,66.06,0,0,0,161.68,158.58Z"
        transform="translate(0 0)"
        fill="#ffffff"
      />
      <path
        id="Fantástica"
        d="M202.08,38.48V2.5h21.53V6H206.08v14H220.9v3.54H206.08V38.48Zm43.31-18.15V33.64c.11,1.29,1.11,2,3,2.29L248.26,39q-4.11,0-6.19-2.08A22.77,22.77,0,0,1,232.71,39a7.06,7.06,0,0,1-5.46-2,8.26,8.26,0,0,1-1.88-5.82c0-2.54.65-4.4,1.93-5.59s3.29-1.93,6-2.21l8.16-.78V20.33a5.18,5.18,0,0,0-1.14-3.8,4.23,4.23,0,0,0-3.12-1.14,73.22,73.22,0,0,0-8.63.52l-1.61.15-.16-3A52.33,52.33,0,0,1,237,12q4.42,0,6.42,2C244.73,15.34,245.39,17.45,245.39,20.33Zm-16,10.61q0,4.79,4,4.78a21,21,0,0,0,7-1.2l1.2-.41V25.53l-7.7.73a5,5,0,0,0-3.38,1.35A4.73,4.73,0,0,0,229.38,30.94ZM257,38.48h-3.9v-26h3.85V14.3A16.61,16.61,0,0,1,265,12c3.46,0,5.8.94,7,2.81s1.8,5.2,1.8,10V38.48h-3.85V24.86q0-5.41-1.07-7.41t-4.55-2a13.51,13.51,0,0,0-3.51.49,17.46,17.46,0,0,0-2.83,1l-1,.47Zm37.34-22.62h-8.27V28.29c0,3,.21,4.94.65,5.87s1.46,1.41,3.09,1.4l4.63-.31.26,3.23a36.24,36.24,0,0,1-5.3.57c-2.7,0-4.58-.66-5.62-2s-1.56-3.83-1.56-7.54V15.86h-3.69V12.48h3.69v-8h3.85v8h8.27Zm23.14,4.47V33.64c.1,1.29,1.11,2,3,2.29L320.33,39c-2.74,0-4.81-.69-6.19-2.08A22.77,22.77,0,0,1,304.78,39a7.06,7.06,0,0,1-5.46-2,8.2,8.2,0,0,1-1.87-5.82q0-3.81,1.92-5.59c1.28-1.2,3.29-1.93,6-2.21l8.17-.78V20.33a5.23,5.23,0,0,0-1.15-3.8,4.23,4.23,0,0,0-3.12-1.14,73.22,73.22,0,0,0-8.63.52l-1.61.15-.16-3A52.42,52.42,0,0,1,309,12q4.43,0,6.42,2C316.8,15.34,317.47,17.45,317.47,20.33Zm-16,10.61q0,4.79,3.95,4.78a20.93,20.93,0,0,0,7-1.2l1.2-.41V25.53l-7.7.73a5,5,0,0,0-3.38,1.35A4.78,4.78,0,0,0,301.45,30.94ZM301.5,5.1,312.73,0l1.36,3.32-11.5,4.42Zm31.83,10.34q-5.67,0-5.67,4A2.73,2.73,0,0,0,329,22a22.09,22.09,0,0,0,5.93,1.56c3.08.54,5.27,1.29,6.55,2.26s1.92,2.79,1.92,5.46-.86,4.63-2.57,5.88S336.57,39,333.27,39a47.23,47.23,0,0,1-7.59-.73L324.12,38l.21-3.38a67.17,67.17,0,0,0,8.94.89,8.93,8.93,0,0,0,4.6-1,3.46,3.46,0,0,0,1.59-3.22,3.27,3.27,0,0,0-1.35-3.07,20,20,0,0,0-5.93-1.53q-4.57-.74-6.5-2.13c-1.28-.94-1.93-2.67-1.93-5.2a6.34,6.34,0,0,1,2.68-5.62A11.6,11.6,0,0,1,333.11,12a54.4,54.4,0,0,1,8,.73l1.46.26-.1,3.33A68,68,0,0,0,333.33,15.44Zm29.48.42h-8.27V28.29q0,4.47.65,5.87c.44.94,1.47,1.41,3.1,1.4l4.62-.31.26,3.23a36.24,36.24,0,0,1-5.3.57q-4,0-5.61-2t-1.56-7.54V15.86H347V12.48h3.69v-8h3.85v8h8.26Zm4.78,22.62v-26h3.9v26Zm0-31.88V2.08h3.9V6.6ZM388.71,12a45.59,45.59,0,0,1,5.82.62l1.25.16-.16,3.17c-2-.26-4.08-.41-6.13-.47-2.95,0-4.95.71-6,2.11s-1.59,4-1.59,7.8.5,6.44,1.49,7.93,3,2.24,6.16,2.24l6.13-.47.16,3.22a53,53,0,0,1-7.23.73q-6.08,0-8.4-3.12t-2.31-10.53q0-7.41,2.5-10.4C382.05,13,384.83,12,388.71,12ZM420,20.33V33.64c.1,1.29,1.11,2,3,2.29L422.87,39q-4.11,0-6.19-2.08A22.77,22.77,0,0,1,407.32,39a7.07,7.07,0,0,1-5.46-2A8.3,8.3,0,0,1,400,31.15q0-3.81,1.92-5.59c1.29-1.2,3.3-1.93,6-2.21l8.16-.78V20.33a5.27,5.27,0,0,0-1.14-3.8,4.23,4.23,0,0,0-3.12-1.14,73.39,73.39,0,0,0-8.64.52l-1.61.15-.15-3A52.33,52.33,0,0,1,411.59,12Q416,12,418,14c1.33,1.36,2,3.47,2,6.35ZM404,30.94q0,4.79,4,4.78a20.87,20.87,0,0,0,7-1.2l1.2-.41V25.53l-7.7.73A5,5,0,0,0,405,27.61,4.83,4.83,0,0,0,404,30.94Z"
        transform="translate(0 0)"
        fill="#ffffff"
      />
    </g>
  </svg>
)
